// close mega menu on outside click
document.addEventListener('click', function(event) {
  document.querySelectorAll('details[open]').forEach(function(details) {
    if (details.querySelector('.header__mega__submenu') && !details.contains(event.target)) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  });
});

// global slider start
function initCustomSwiper(selector, options = {}) {
  const finalOptions = {
    loop: false,
    autoHeight: true,
    ...options,
    on: {
      init() {
        toggleSwiperNav(this);
        options.on?.init?.(this);
      },
      resize() {
        toggleSwiperNav(this);
        options.on?.resize?.(this);
      }
    }
  };

  return new Swiper(selector, finalOptions);
}

function toggleSwiperNav(swiper) {
  const total = swiper?.slides?.length ?? 0;
  const perView = swiper?.params?.slidesPerView ?? 1;
  const prev = document.querySelector(swiper?.params?.navigation?.prevEl);
  const next = document.querySelector(swiper?.params?.navigation?.nextEl);

  const shouldHide = typeof perView === 'number' && total <= perView;
  [prev, next].forEach(el => el && (el.style.display = shouldHide ? 'none' : ''));
}
// global slider end
// customer review slider
const reviewslider = new Swiper('.customer-review-slider', {
  breakpoints: {
    992: {
      slidesPerView: 1,
    },
  },
  loop: true,
  autoHeight: true,
  spaceBetween: 10,
  slidesPerView: 2,
  navigation: {
    nextEl: '.crs-button-next',
    prevEl: '.crs-button-prev',
  },
});

// review-story slider
const reviewStoryslider = new Swiper('.review-story-slider', {
  breakpoints: {
    992: {
      slidesPerView: 1,
    },
  },
  loop: false,
  autoHeight: true,
  spaceBetween: 10,
  slidesPerView: 2,
  navigation: {
    nextEl: '.rss-button-next',
    prevEl: '.rss-button-prev',
  },
});


// video slider 
const videoslider = new Swiper('.video-slider', {
  breakpoints: {
    650: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    }
  },
  loop: true,
  autoHeight: true,
  slidesPerView: 4,
  spaceBetween: 10,
  navigation: {
    nextEl: '.vrs-button-next',
    prevEl: '.vrs-button-prev',
  },
});

// Collection slider 
const collectionSlider = new Swiper('.collection-slider', {
  breakpoints: {
    650: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    }
  },
  loop: true,
  autoHeight: true,
  slidesPerView: 4,
  spaceBetween: 16,
  navigation: {
    nextEl: '.cs-button-next',
    prevEl: '.cs-button-prev',
  },
});
// expoer review sldier 
const experReviewSlider = new Swiper('.expert-review-slider', {
  loop: true,
  autoHeight: true,
  slidesPerView: 1,
  pagination: {
      el: '.ers-pagination',
      clickable: true,
  },
});

// hero banner sldier 
const heroBannerSlider = new Swiper('.hero-banner-slider', {
  loop: false,
  autoHeight: true,
  slidesPerView: 1,
  autoplay: 3000,
  preventClicksPropagation: false,
  preventClicks: false,
  speed: 500,
  pagination: {
      el: '.hbs-pagination',
      clickable: true,
  },
});

// marquee slider 
const marqueeSlider = new Swiper('.ticker-slider', {
  loop: true,
  autoHeight: true,
  slidesPerView: 'auto',
  autoplay: {
    delay: 0, // 0ms delay = continuous scroll
    disableOnInteraction: false,
  },
  speed: 5000,
});

// fplcs slider 
initCustomSwiper('.fplcs-slider', {
  breakpoints: {
    650: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 4,
    }
  },
  loop: false,
  autoHeight: true,
  slidesPerView: 6,
  spaceBetween: 10,
  navigation: {
    nextEl: '.fplcs-button-next',
    prevEl: '.fplcs-button-prev',
  },
});

// fplcs slider 
initCustomSwiper('.asl-slider', {
  breakpoints: {
    650: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 4,
    }
  },
  loop: false,
  autoHeight: true,
  slidesPerView: 6,
  spaceBetween: 10,
  navigation: {
    nextEl: '.asl-button-next',
    prevEl: '.asl-button-prev',
  },
});

// how to use sldier
initCustomSwiper('.how-use-slider', {
  breakpoints: {
    650: {
      slidesPerView: 1,
    },
    992: {
      slidesPerView: 2,
    }
  },
  loop: false,
  autoHeight: true,
  slidesPerView: 3,
  spaceBetween: 20,
  navigation: {
    nextEl: '.hts-button-next',
    prevEl: '.hts-button-prev',
  },
});

// swiper wrapper
initCustomSwiper('.slide-review-slider', {
  breakpoints: {
    650: {
      slidesPerView: 1,
    },
    992: {
      slidesPerView: 2,
    }
  },
  loop: false,
  autoHeight: true,
  slidesPerView: 3,
  spaceBetween: 10,
  navigation: {
    nextEl: '.srs-button-next',
    prevEl: '.srs-button-prev',
  },
});

// Accordion start 
(function Accordion() {
  const triggers = document.querySelectorAll('[data-toggle="collapse"]');
  let activeToggle;

  // Ensure all collapse elements are closed on load
  document.querySelectorAll('.is-active').forEach(el => {
    el.classList.remove('is-active');
    el.style.height = null;
  });

  triggers &&
  triggers.forEach(trigger => {
    trigger.collapseTarget = document.querySelector(
      trigger.hash || trigger.dataset.target);

    trigger.collapseTarget.dataset.parent &&
    trigger.collapseTarget.classList.contains("is-active") && (
      activeToggle = trigger);

    trigger.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      toggle(trigger);
    });

    trigger.collapseTarget.addEventListener("transitionend", ({ target }) => {
      if (!target.classList.contains("is-active")) return;
      target.style.height = null;
    });
  });

  function toggle(trigger) {
    if (trigger.collapseTarget.classList.contains("is-active")) {
      close(trigger);
      activeToggle = null;
    } else {
      activeToggle &&
      activeToggle.collapseTarget.dataset.parent &&
      close(activeToggle);

      trigger.collapseTarget.dataset.parent && (activeToggle = trigger);
      open(trigger);
    }
  }

  function close(trigger) {
    setHeight(trigger.collapseTarget);

    trigger.parentElement.classList.remove("is-active");
    trigger.classList.remove("is-active");
    trigger.collapseTarget.classList.remove("is-active");

    setTimeout(() => {
      trigger.collapseTarget.style.height = null;
    }, 0);
  }

  function open(trigger) {
    trigger.classList.add("is-active");
    trigger.parentElement.classList.add("is-active");

    setTimeout(() => {
      setHeight(trigger.collapseTarget);
      trigger.collapseTarget.classList.add("is-active");
    }, 0);
  }

  function setHeight(target) {
    target.style.height = target.scrollHeight + "px";
  }
})();

// Accordion end 

document.addEventListener("DOMContentLoaded", function () {
  const mediaList = document.querySelector(".product__media-list");
  if (mediaList) {
    const items = mediaList.querySelectorAll("li");
    const hasActive = Array.from(items).some(item =>
      item.classList.contains("is-active")
    );
    if (!hasActive && items.length > 0) {
      items[0].classList.add("is-active");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
	$('.popup-youtube').magnificPopup({
    type: 'iframe'
  });
})


// click to show
document.querySelectorAll(".toggle-product").forEach(item => {
  item.addEventListener("click", function (event) {
    event.stopPropagation(); 
    if (this.classList.contains("active")) return;
    document.querySelectorAll(".toggle-product").forEach(el => {
      el.classList.remove("active");
    });
    this.classList.add("active");
  });
});

document.addEventListener("click", function () {
  document.querySelectorAll(".toggle-product").forEach(el => {
    el.classList.remove("active");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 991) {
    const blocks = document.querySelectorAll(".footer-block");
    blocks.forEach(block => {
      const heading = block.querySelector(".footer-block__heading");
      const content = heading?.nextElementSibling;
      if (!heading || !content || !content.classList.contains("footer-block__details-content")) return;
      heading.addEventListener("click", function () {
        const isActive = block.classList.contains("active");
        blocks.forEach(b => b.classList.remove("active"));
        if (!isActive) {
          block.classList.add("active");
        }
      });
    });
  }
});
